
<div class="lm-border pa-3" style="position:relative;">
    <div style="position: absolute; right: 10px;">
        <div class="v-flex">
            <v-spacer />
            <v-switch
                v-model = "favorite"
                :ripple = "false"
                class   = "mt-0"
                dense
                hide-details
                @change = "onFavorite"
            />
        </div>
        <div class="contact-favorite-hint" v-if="favorite">
            Kontakt für Begehung
        </div>
    </div>
    <div class="contact-company primary--text">
        {{ contact.company }}
    </div>
    <div class="contact-name">
        {{ contact.name }}
    </div>
    <div class="contact-type  primary--text">
        {{ contact.type ? contact.type : "---" }}
    </div>
    <div class="contact-phone">
        <v-icon>mdi-phone</v-icon>
        <f-copy-text :text="phone(contact.phone)" v-if="contact.phone" />
        <span v-if="!contact.phone">---</span>
    </div>
    <div class="contact-phone">
        <v-icon>mdi-cellphone</v-icon>
        <f-copy-text :text="phone(contact.mobile)" v-if="contact.mobile"/>
        <span v-if="!contact.mobile">---</span>
    </div>
    <div class="contact-mail">
        <v-icon>mdi-outline</v-icon>
        <a :href = "'mailto:' + contact.email ">{{contact.email}}</a>
    </div>
</div>
